import { defineComponent as _defineComponent } from 'vue';
import { createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue";
import { computed } from "vue";
import { ElSelect, ElOption } from "element-plus";
export default /*#__PURE__*/ _defineComponent({
    __name: 'EnumListComponentVariableBuiltValue',
    props: {
        value: {}
    },
    setup(__props) {
        const props = __props;
        const isEnumList = (value) => {
            return (Array.isArray(value) && value.every((item) => typeof item === "string"));
        };
        const valueProxy = computed(() => {
            return isEnumList(props.value) ? props.value : [];
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createCommentVNode(" Need this outer div to prevent ComponentVaribleValueInput props from colliding with TagSet props "),
                _createElementVNode("div", null, [
                    _createVNode(_unref(ElSelect), {
                        modelValue: valueProxy.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((valueProxy).value = $event)),
                        placeholder: '+ New Value',
                        readonly: true
                    }, {
                        default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(valueProxy.value, (item) => {
                                return (_openBlock(), _createBlock(_unref(ElOption), {
                                    key: item,
                                    label: item,
                                    value: item
                                }, null, 8 /* PROPS */, ["label", "value"]));
                            }), 128 /* KEYED_FRAGMENT */))
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["modelValue"])
                ])
            ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */));
        };
    }
});
